/**
 * Traducciones ESPAÑOL -> INGLÉS del Dashboard del protocolo (`components/Dashboard.tsx`).
 *
 * La clave es la cadena en español EXACTA que aparece en el código, con sus acentos, mayúsculas,
 * signos y marcadores de interpolación `{x}` intactos. Lo que no esté aquí cae al español.
 * NO se traducen nombres propios (Keellabs, Uniswap…) ni símbolos de token.
 */
export const DASHBOARD: Record<string, string> = {
  // --- cabecera / navegación ---
  "← Volver": "← Back",
  "Protocolo": "Protocol",
  "Dashboard": "Dashboard",
  "Estado del protocolo en tiempo real — leído directo de la cadena, sin backend intermediario.":
    "Protocol status in real time — read straight from the chain, no backend in between.",
  "En vivo": "Live",
  "Todas": "All",
  "No pude leer {redes}: queda fuera de las cifras.": "Couldn't read {redes}: it's left out of the figures.",

  // --- KPIs ---
  "Capital gestionado": "Capital under management",
  "{pct}% del capital": "{pct}% of the capital",
  "valorado al precio de ahora": "valued at the current price",
  "Volumen del protocolo": "Protocol volume",
  "capital total depositado a lo largo del tiempo, a coste": "total capital deposited over time, at cost",
  "Posiciones abiertas": "Open positions",
  "en": "in",
  "de {total} redes": "of {total} networks",
  "{monto} de media": "{monto} on average",
  "Dentro de rango": "In range",
  "cobrando comisiones · {fuera} fuera de rango": "earning fees · {fuera} out of range",
  "Ganancias generadas": "Profits generated",
  "para los dueños, desde que abrieron": "for the owners, since they opened",
  "Valor medio por posición": "Average value per position",
  "capital de trabajo puesto por posición": "working capital put in per position",
  "Comisión de Keellabs": "Keellabs fee",
  "de las ganancias,": "of the profits,",
  "nunca del capital": "never of the capital",

  // --- distribución: capital por par ---
  "Capital por par": "Capital by pair",
  "Top {n}": "Top {n}",
  "Dónde está realmente el dinero, par por par.": "Where the money really is, pair by pair.",
  "Sin posiciones que mostrar.": "No positions to show.",

  // --- distribución: posiciones por red ---
  "Posiciones por red": "Positions by network",
  "{n} en total": "{n} in total",
  "Cuántas están cobrando y cuántas se han salido del rango.": "How many are earning and how many have fallen out of range.",
  "{n} posición": "{n} position",
  "{n} posiciones": "{n} positions",
  "Dentro de rango (cobrando)": "In range (earning)",
  "Fuera de rango": "Out of range",

  // --- tabla de piscinas ---
  "Piscinas cerradas": "Closed pools",
  "Piscinas activas": "Active pools",
  "Posiciones ya cerradas y lo que repartieron a sus dueños mientras vivieron.":
    "Positions already closed and what they paid out to their owners while they lived.",
  "Cada posición abierta, de mayor a menor capital.": "Each open position, from most to least capital.",
  "En rango": "In range",
  "Fuera": "Out",
  "Cerradas": "Closed",
  "Par": "Pair",
  "Red": "Network",
  "Duró": "Lasted",
  "Capital": "Capital",
  "Salió con": "Left with",
  "Ganado": "Earned",
  "Total repartido por las {n} cerradas": "Total paid out by the {n} closed",
  "Todavía no hay piscinas cerradas en esta red.": "No closed pools on this network yet.",
  "Todavía no hay piscinas cerradas.": "No closed pools yet.",
  "Trabajando": "Working",
  "Estado": "Status",
  "Cobrando": "Earning",
  "Enlaces": "Links",
  "Pool ↗": "Pool ↗",
  "Ver la pool en {sitio}": "View the pool on {sitio}",
  "Ver el contrato del vault en el explorador": "View the vault contract on the explorer",
  "Ninguna posición con ese estado.": "No positions with that status.",
  "Todavía no hay posiciones abiertas en esta red.": "No open positions on this network yet.",

  // --- series históricas ---
  "Series históricas": "Historical series",
  "La actividad del protocolo a lo largo del tiempo · {red}": "Protocol activity over time · {red}",
  "La actividad del protocolo a lo largo del tiempo.": "Protocol activity over time.",
  "Diario": "Daily",
  "Semanal": "Weekly",
  "Mensual": "Monthly",
  "{total} total": "{total} total",
  "Rebalanceos": "Rebalances",
  "Reajustes ejecutados por el robot": "Adjustments run by the robot",
  "Posiciones nuevas": "New positions",
  "Piscinas abiertas o reabiertas": "Pools opened or reopened",
  "Repartos de comisión": "Fee payouts",
  "Cobros de comisiones registrados": "Fee collections recorded",
  "Las series históricas se activan cuando el indexer publique los datos de cada red.":
    "The historical series turn on once the indexer publishes each network's data.",
  "Sin actividad registrada en este periodo.": "No activity recorded in this period.",
};
